module.exports = __webpack_public_path__ + "c01813abf20a6c66ea6bf5d5bb61ef34.svg";